import { Router } from 'pjax';
import Vue from 'vue';
import Guides from '../../lib/components/Holocron/Guides';
import Tours from '../../lib/components/Holocron/Tours';

Router.get('guides-and-tours', function() {
  let vueContainer = document.getElementById('guides-and-tours');

  if (vueContainer) {
    new Vue({
      el: vueContainer,
      components: {
        Guides,
        Tours
      }
    });
  }
});
